import { useRef } from "react";

/**
 * Builds a GDS `onMenuToggle` handler that runs `onClose` when the menu closes.
 *
 * GDS fires `onMenuToggle` on mount reporting "closed", so only a true
 * open -> closed transition counts.
 */
export const useOnMenuClose = (onClose: () => void) => {
  const wasOpen = useRef(false);

  return (isOpen: boolean) => {
    const closed = wasOpen.current && !isOpen;
    wasOpen.current = isOpen;
    if (closed) onClose();
  };
};
